var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38736 11.1608C8.40072 11.1779 8.4178 11.1917 8.43729 11.2012C8.45678 11.2107 8.47818 11.2156 8.49986 11.2156C8.52154 11.2156 8.54294 11.2107 8.56243 11.2012C8.58192 11.1917 8.599 11.1779 8.61236 11.1608L10.6124 8.63043C10.6856 8.53757 10.6195 8.40007 10.4999 8.40007H9.17665V2.35721C9.17665 2.27864 9.11236 2.21436 9.03379 2.21436H7.96236C7.88379 2.21436 7.8195 2.27864 7.8195 2.35721V8.39828H6.49986C6.38022 8.39828 6.31415 8.53578 6.38736 8.62864L8.38736 11.1608ZM15.0356 10.5358H13.9641C13.8856 10.5358 13.8213 10.6001 13.8213 10.6786V13.4286H3.17843V10.6786C3.17843 10.6001 3.11415 10.5358 3.03557 10.5358H1.96415C1.88557 10.5358 1.82129 10.6001 1.82129 10.6786V14.2144C1.82129 14.5304 2.07665 14.7858 2.39272 14.7858H14.607C14.9231 14.7858 15.1784 14.5304 15.1784 14.2144V10.6786C15.1784 10.6001 15.1141 10.5358 15.0356 10.5358Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.aa531c49dd7ba738801922fb4134a112.svg";
export { ForwardRef as ReactComponent };